module.exports = __webpack_public_path__ + "static/media/halloween7.4a523f4b.webp";